export default {"src":"/_next/static/media/carbon_vehicle-connected.3d96559e.svg","height":53,"width":53,"blurWidth":0,"blurHeight":0};